import axios from 'axios';

const apiClient = axios.create({
  baseURL: "",
});

const PUBLIC_PATHS = ["/", "/Register"];

function isPublicPath() {
  const path = window.location.pathname;
  return PUBLIC_PATHS.includes(path) || path.startsWith("/compliance/");
}

// Attach the access token to every request
apiClient.interceptors.request.use(
  (config) => {
    const tokensString = localStorage.getItem('tokens');
    if (tokensString) {
      try {
        const tokens = JSON.parse(tokensString);
        if (tokens?.AccessToken) {
          config.headers.Authorization = `Bearer ${tokens.AccessToken}`;
        }
      } catch {
        localStorage.removeItem('tokens');
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401 && !isPublicPath()) {
      const url = error.config?.url || "";
      if (!url.includes("/user/login") && !url.includes("/user/validate-session")) {
        window.dispatchEvent(new CustomEvent("dyc:session-expired"));
      }
    } else if (status === 403) {
      error.userMessage = "You don't have permission to perform this action.";
    } else if (status >= 500) {
      error.userMessage = "Something went wrong on our end. Please try again.";
    } else if (!error.response) {
      error.userMessage = "Unable to connect. Check your internet connection.";
    }

    return Promise.reject(error);
  }
);

export default apiClient;